module.exports = __webpack_public_path__ + "public/images/goat-wizard.8029df35cbcc6cd7ea2a0685baec7b02.webp";